import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { UserState } from './types';
import { StateStatus } from '../../enums/StateStatus';

export const defaultUserState: UserState = {
  userInfo: null,
  status: StateStatus.Initial,
  error: null
};

export default function reducer(state: UserState = defaultUserState, action: Actions): UserState {
  switch (action.type) {
    case ActionTypes.GET_USER_INFO_ERROR:
      return { ...state, error: action.payload };
    case ActionTypes.GET_USER_INFO:
      return { ...state, status: StateStatus.Busy };
    case ActionTypes.GET_USER_INFO_SUCCESS:
      return { ...state, status: StateStatus.Loaded, userInfo: action.payload };
    default:
      return state;
  }
}
